import Link from 'next/link';
import type React from 'react';
import type {UserMeClipType} from '../../../../core/entities/clip/constants';
import {getFavoriteButtonComponent} from '../../../../shared/services/getFavoriteButtonComponent';
import {getResourceLinkType} from '../../../../shared/services/getResourceLinkType';
import {ClipListBase} from './ClipListBase';
import type {IClipContentProps, IClipListProps} from './ClipListInterfaces';

const ClipContent: React.FC<IClipContentProps> = ({clip}) => {
  const FavoriteButtonComponent = getFavoriteButtonComponent(
    clip.type as UserMeClipType,
  );
  const resourceLinkType = getResourceLinkType(clip.type as UserMeClipType);

  return (
    <li className="flex h-32 items-center justify-between border-b-[1px] border-solid border-background-3 last:border-b-0">
      <Link
        href={`/${resourceLinkType}/${clip.content.id}`}
        className="block w-[530px] truncate text-sm font-bold text-link-1 hover:underline"
      >
        {clip.content.title}
      </Link>
      <FavoriteButtonComponent clip={clip} />
    </li>
  );
};

export const ClipList: React.FC<IClipListProps> = (props) => (
  <ClipListBase {...props} ClipContentComponent={ClipContent} />
);
